<template>
  <v-tooltip
    content-class="table__overflow-tooltip"
    location="top"
    :text="text"
  >
    <template #activator="{ props: tooltipProps }">
      <span
        :aria-describedby="tooltipProps['aria-describedby']"
        class="table__primary-text"
        :tabindex="text ? 0 : undefined"
        @blur="tooltipProps.onBlur"
        @focus="showOverflowTooltip($event, tooltipProps.onFocus)"
        @mouseenter="showOverflowTooltip($event, tooltipProps.onMouseenter)"
        @mouseleave="tooltipProps.onMouseleave"
      >
        {{ text || '—' }}
      </span>
    </template>
  </v-tooltip>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: '',
  },
})

function showOverflowTooltip (event, openTooltip) {
  if (event.currentTarget.scrollWidth > event.currentTarget.clientWidth) {
    openTooltip(event)
  }
}
</script>
